import { Table, TableBody, TableCell, TableRow } from '@mui/material';
import React from 'react';
import { overridings } from '../../themes/DarkTheme';

function SumRowNormalPrice({ sumNormalPricePerMonth, dueDate, isMobile }) {
    return (
        <>
            {isMobile ? (
                <Table>
                    <TableRow
                        sx={{
                            backgroundColor: overridings.palette.primary.light
                        }}
                    >
                        <TableCell
                            sx={{
                                color: overridings.palette.primary.contrastText
                            }}
                        >
                            I alt til betaling den {dueDate}
                        </TableCell>
                        <TableCell
                            sx={{
                                color: overridings.palette.primary.contrastText
                            }}
                        >
                            {sumNormalPricePerMonth
                                .toString()
                                .replaceAll('.', ',')}{' '}
                            kr.
                        </TableCell>
                    </TableRow>
                </Table>
            ) : (
                <Table
                    sx={{
                        overflow: 'unset'
                    }}
                >
                    <TableBody>
                        <TableRow
                            sx={{
                                backgroundColor:
                                    overridings.palette.primary.light
                            }}
                        >
                            <TableCell
                                component="th"
                                scope="row"
                                sx={{
                                    color:
                                        overridings.palette.primary
                                            .contrastText,
                                    minWidth: '95px',
                                    width: '11%',
                                    '@media (max-width: 600px)': {
                                        fontSize: '10px',
                                        minWidth: 'unset',
                                        width: 'auto'
                                    }
                                }}
                            >
                                <b>I alt</b>
                            </TableCell>

                            <TableCell
                                sx={{
                                    minWidth: '250px',
                                    width: '25%',
                                    '@media (max-width: 600px)': {
                                        minWidth: 'unset'
                                    }
                                }}
                            ></TableCell>

                            <TableCell
                                sx={{
                                    color:
                                        overridings.palette.primary
                                            .contrastText,

                                    minWidth: '115px',
                                    width: '13%',
                                    '@media (max-width: 600px)': {
                                        fontSize: '10px',
                                        minWidth: 'unset'
                                    }
                                }}
                                align="center"
                            >
                                <b>
                                    {' '}
                                    {sumNormalPricePerMonth
                                        .toString()
                                        .replaceAll('.', ',')}
                                </b>{' '}
                                kr.
                            </TableCell>
                            <TableCell
                                sx={{
                                    minWidth: '115px',
                                    width: '13%',
                                    '@media (max-width: 600px)': {
                                        minWidth: 'unset'
                                    }
                                }}
                            ></TableCell>

                            <TableCell
                                sx={{
                                    color:
                                        overridings.palette.primary
                                            .contrastText,
                                    minWidth: '115px',
                                    width: '13%',
                                    '@media (max-width: 600px)': {
                                        minWidth: 'unset'
                                    }
                                }}
                                align="center"
                            ></TableCell>

                            <TableCell
                                sx={{
                                    color:
                                        overridings.palette.primary
                                            .contrastText,
                                    '@media (max-width: 600px)': {
                                        fontSize: '10px',
                                        minWidth: 'unset'
                                    }
                                }}
                                align="right"
                            >
                                <b>Opkræves den {dueDate}</b>
                            </TableCell>
                        </TableRow>
                    </TableBody>
                </Table>
            )}
        </>
    );
}

export default SumRowNormalPrice;
